import { render } from "./ClientsModal.vue?vue&type=template&id=3797233e&scoped=true"
import script from "./ClientsModal.vue?vue&type=script&lang=js"
export * from "./ClientsModal.vue?vue&type=script&lang=js"

import "./ClientsModal.vue?vue&type=style&index=0&id=3797233e&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3797233e"]])

export default __exports__